module.exports = __webpack_public_path__ + "img/29.9d93d2b4.jpg";